import { Component, computed, input, output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-profile-options',
  imports: [
    MatIconModule,
    MatMenuModule,
    MatButtonModule,
    MatTooltipModule,
    TranslatePipe,
  ],
  templateUrl: './profile-options.html',
  styleUrl: './profile-options.scss',
})
export class ProfileOptions {
  userEmail = input('user@example.com');
  userName = input('');

  /** Emitted so the shell — not this shared component — talks to the auth store. */
  readonly logoutRequested = output<void>();

  protected readonly userEmailToShow = computed(() => {
    const email = this.userEmail();
    const maxLength = 25;

    if (email.length > maxLength) {
      const atIndex = email.lastIndexOf('@');
      return `${email.slice(0, 8)}...${email.slice(atIndex)}`;
    }

    return email;
  });
}
